// Module
var code = `<label tid="emailAddressLabel" id="emailAddressLabel" for="emailaddress" class="Field-label">
    Email Address
    <span *ngIf="personalInfoData.showRequired" class="asterisk-required">&nbsp;&#42;</span>
    <!-- show when looking up email (ng-if does not work for spinners) -->
    <span [style.visibility]="personalInfoData.isValidatingEmail ? 'visible' : 'hidden'" class="u-mL4">
                <span class="Loader Loader--sm Loader--blue"></span>
            </span>
</label>
<input type="email"
       (blur)="emailLookup()"
       class="Input"
       id="emailaddress"
       tid="emailaddress"
       maxlength="100"
       [(ngModel)]="emailValue"
       required
       aria-invalid="emailAddressError"
       attr.aria-describedby="{{personalInfoData.emailAddressError && 'emailaddress-error' || undefined }}">
<span class="Field-error" tid="emailaddress-error" id="emailaddress-error">{{personalInfoData.emailAddressErrorMessage}}</span>
`;
// Exports
module.exports = code;